/* eslint-disable no-unused-expressions */
import * as React from "react";
import { Input, Table, Button, DatePicker } from "antd";
import { useState, useEffect } from "react";
import { Space } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import "dayjs/locale/es";
import { EditOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

import {
  formatIntDate,
  formatDate,
} from "../../../utils/utils";

dayjs.extend(calendar);

export const EditableTable = ({
  dataSource,
  onHandleEvent,
  onConfirm,
  enabledToEdit,
}) => {
  const [tableData, setTableData] = useState(dataSource);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const newData = [...tableData];
    setTableData(newData);
  }, []);

  const onInputChange = (key, index, type) => (e) => {
    const newData = [...tableData];

    newData[index][key] =
      type !== "date"
        ? e.target.value
        : parseInt(formatDate(e.$d).replace(/-/g, ""));
    setTableData(newData);
  };

  const handleOnConfirm = () => {
    setIsDisabled(true);
    onConfirm(tableData);
  };

  const handleEditProducts = () => {
    setIsDisabled(!isDisabled);
  };

  const columns = [
    {
      title: "Material",
      dataIndex: "material",
      key: "material",
    },
    {
      title: "Cant. Total",
      dataIndex: "cantidad",
      key: "cantidad",
      render: (text, record, index) => (
        <Input
          value={text}
          type="number"
          onChange={onInputChange("cantidad", index)}
          style={{ maxWidth: 80 }}
          disabled={isDisabled}
        />
      ),
    },
    {
      title: "Costo",
      dataIndex: "costo",
      key: "costo",
      render: (text, record, index) => (
        <Input
          value={text}
          onChange={onInputChange("costo", index)}
          style={{ maxWidth: 120 }}
          disabled={isDisabled}
        />
      ),
    },
    {
      title: "Fecha Promesa",
      dataIndex: "fechaPromesa",
      key: "fechaPromesa",
      render: (text, record, index) => (
        <DatePicker
          locale={locale}
          size="large"
          style={{ minWidth: 140 }}
          defaultValue={dayjs(formatIntDate(text.toString()), "YYYY-MM-DD")}
          onChange={onInputChange("fechaPromesa", index, "date")}
          disabled={isDisabled}
        />
      ),
    },
    {
      title: "Tirilla",
      dataIndex: "tirilla",
      key: "tirilla",
      render: (text, record, index) => (
        <Input
          value={text}
          onChange={onInputChange("tirilla", index)}
          disabled={isDisabled}
        />
      ),
    },
    {
      title: "Referencia",
      dataIndex: "referencia",
      key: "referencia",
      render: (text, record, index) => (
        <Input
          value={text}
          onChange={onInputChange("referencia", index)}
          disabled={isDisabled}
        />
      ),
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => onHandleEvent(record)}
          >
            Mostrar Eventos
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="products-editable">
      <div className="products-editable-actions">
        {(!enabledToEdit && isDisabled) && (
          <Button
            type="link"
            onClick={handleEditProducts}
            icon={<EditOutlined />}
          >
            Editar
          </Button>
        )}
        {!isDisabled && (
          <Button type="default" onClick={handleOnConfirm} className="btn-primary"
          >
            Actualizar Productos
          </Button>
        )}
      </div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={tableData}
        pagination={false}
      />
    </div>
  );
};
